import React, { useEffect, useState } from "react";
import QRCodeLib from "qrcode";

/**
 * Client-side generated QR code (PNG data URL).
 * Always works — no server upload, no migration on deploy.
 *
 * Props:
 *  - value: string (URL or text to encode)  default: https://letgowelllness.com
 *  - dark:  string hex color for modules    default: #1C1917
 *  - light: string hex color for background default: #FFFFFF
 *  - size:  pixel size of the generated PNG default: 1024 (downscaled by CSS)
 *  - margin: quiet zone modules             default: 2
 *  - className: applied to <img>
 *  - style:     style on <img>
 *  - alt:       alt text
 */
export default function QRCode({
  value = "https://letgowelllness.com",
  dark = "#1C1917",
  light = "#FFFFFF",
  size = 1024,
  margin = 2,
  className = "",
  style,
  alt = "QR code",
  ...rest
}) {
  const [src, setSrc] = useState("");

  useEffect(() => {
    let cancelled = false;
    QRCodeLib.toDataURL(value, {
      errorCorrectionLevel: "H",
      margin,
      width: size,
      color: { dark, light },
    })
      .then((url) => { if (!cancelled) setSrc(url); })
      .catch(() => { if (!cancelled) setSrc(""); });
    return () => { cancelled = true; };
  }, [value, dark, light, size, margin]);

  if (!src) {
    return (
      <span
        aria-label={alt}
        className={className}
        style={{ background: light, display: "inline-block", ...style }}
        {...rest}
      />
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      crossOrigin="anonymous"
      className={className}
      style={style}
      {...rest}
    />
  );
}
